import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from '../../../locales';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@axa-asia/emma-stylesheet/lib/components/Modal';
import { resolvePublicAssets, isExternalAssets } from '../../../utils';
import { getAvators } from '../../../selectors/configSelectors';
import './styles.scss';
import { getHealthKeeperDialogState } from '../../../modules/healthkeeper/selectors/healthKeeperSelector';
import {
  HIDE_CREATE_HEALTH_KEEPER_ACCOUNT_DIALOG,
  CREATE_HEALTH_KEEPER_ACCOUNT,
} from '../../../modules/healthkeeper/actions/healthKeeperAction';
import { openDisclaimer } from '../../../modules/emma-common/actions';

interface HealthKeeperModalViewProps {
  avator: string;
  isShowModal: boolean;
  hideDialog: () => void;
  createAccount: () => void;
  clickTnc: () => void;
}

interface HealthKeeperModalViewState {
  isCheck: boolean;
}

class HealthKeeperModalView extends Component<
  HealthKeeperModalViewProps,
  HealthKeeperModalViewState
> {
  constructor(props: HealthKeeperModalViewProps) {
    super(props);
    this.state = {
      isCheck: false,
    };
    this.onHideModal = this.onHideModal.bind(this);
    this.confirmTnc = this.confirmTnc.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  onHideModal() {
    const { hideDialog } = this.props;
    hideDialog();
  }

  confirmTnc() {
    const { hideDialog, createAccount } = this.props;
    createAccount();
    hideDialog();
  }

  handleInputChange() {
    this.setState({
      isCheck: !this.state.isCheck,
    });
  }

  render() {
    const { avator, isShowModal } = this.props;
    const { isCheck } = this.state;
    const type = 'emma';

    return (
      <Modal show={isShowModal} onHide={this.onHideModal} type={type}>
        <ModalHeader>
          <div className="emma-modal-header-main-content">
            <div className="emma-modal-header-main-content-img">
              <img
                src={
                  isExternalAssets(avator)
                    ? avator
                    : resolvePublicAssets(avator)
                }
              />
            </div>
            <div className="emma-modal-header-main-content-text-desc">
              {t('HEALTH_KEEPER_MODAL_VIEW_HEADER_DESC')}
            </div>
            <div
              className="emma-modal-header-main-content-text-button"
              onClick={this.onHideModal}
              data-enable-ga
              data-ga-type="button"
            >
              {t('HEALTH_KEEPER_MODAL_VIEW_HEADER_CLOSE_BUTTON')}
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="emma-modal-body-main-content">
            <div className="emma-modal-body-main-content-title">
              {t('HEALTH_KEEPER_MODAL_VIEW_BODY_TITLE')}
            </div>
            <div className="emma-modal-body-main-content-desc">
              {t('HEALTH_KEEPER_MODAL_VIEW_BODY_DESC')}
            </div>
            <div className="emma-modal-body-main-content-check">
              <div className="emma-stylesheet-checkbox">
                <input
                  id="healthKeeperCheckWellness"
                  name="option1"
                  type="checkbox"
                  value="option1"
                  onChange={this.handleInputChange}
                  checked={isCheck}
                />
                <label htmlFor="healthKeeperCheckWellness"></label>
              </div>
              <div className="emma-modal-body-main-content-check-text">
                <div className="emma-modal-body-main-content-check-text-black">
                  {t('HEALTH_KEEPER_MODAL_VIEW_BODY_CHECK_WELLNESS')}
                </div>
                <div
                  className="emma-modal-body-main-content-check-text-blue"
                  onClick={this.props.clickTnc}
                >
                  {t('HEALTH_KEEPER_MODAL_VIEW_BODY_CHECK_TERMS')}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="modal-footer-btn-align__center">
            <button
              className={
                isCheck
                  ? 'emma-stylesheet-primary-default-button'
                  : 'emma-stylesheet-primary-secondary-default-disabled-button'
              }
              disabled={!isCheck}
              onClick={this.confirmTnc}
              data-enable-ga
              data-ga-type="button"
            >
              {t('HEALTH_KEEPER_MODAL_VIEW_FOOTER_BUTTON')}
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }

  static mapStateToProps(state: any) {
    const avators = getAvators(state);
    return {
      avator: avators && avators.discliamerIcon,
      isShowModal: getHealthKeeperDialogState(state),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      hideDialog: () =>
        dispatch({
          type: HIDE_CREATE_HEALTH_KEEPER_ACCOUNT_DIALOG,
        }),
      createAccount: () =>
        dispatch({
          type: CREATE_HEALTH_KEEPER_ACCOUNT,
        }),
      clickTnc: () => dispatch(openDisclaimer('healthKeeperTnc')),
    };
  }
}

export default connect(
  HealthKeeperModalView.mapStateToProps,
  HealthKeeperModalView.mapDispatchToProps,
)(HealthKeeperModalView);
